import { Link } from "react-router-dom";
import { ArrowLeft, Construction, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BRAND_COLORS } from "@/lib/menuData";
import Footer from "@/components/Footer";

export default function AboutUs() {
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: BRAND_COLORS.sandWhite }}>
      {/* Header */}
      <header className="py-4 px-6" style={{ backgroundColor: BRAND_COLORS.deepTeal }}>
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/">
            <Button variant="ghost" size="sm" className="text-white hover:bg-white/10">
              <ArrowLeft className="h-4 w-4 mr-2" /> Back to Home
            </Button>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 py-16 px-6">
        <div className="max-w-md mx-auto text-center">
          <div 
            className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center"
            style={{ backgroundColor: BRAND_COLORS.tropicalAqua + "20" }}
          >
            <Construction className="h-10 w-10" style={{ color: BRAND_COLORS.tropicalAqua }} />
          </div>
          
          <h1 className="text-2xl font-bold mb-4" style={{ fontFamily: "Montserrat", color: BRAND_COLORS.darkSlate }}>
            Coming Soon
          </h1>
          
          <p className="text-gray-600 mb-8">
            This page is under construction.<br />
            Please check back soon or contact us at:
          </p>
          
          <a 
            href="tel:+12518612320"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-xl font-semibold text-white transition-transform hover:scale-105"
            style={{ backgroundColor: BRAND_COLORS.sunsetOrange }}
          >
            <Phone className="h-5 w-5" />
            (251) 861-2320
          </a>
          
          <div className="mt-8">
            <Link to="/">
              <Button 
                variant="outline" 
                className="rounded-xl"
                style={{ borderColor: BRAND_COLORS.deepTeal, color: BRAND_COLORS.deepTeal }}
              >
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back to Home
              </Button>
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
